exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m-TextWithIcon__icon {\n  flex-shrink: 0; }\n\n.m-TextWithIcon__icon--round {\n  position: relative;\n  bottom: 1.5rem;\n  padding: 1rem;\n  border-radius: 9999rem; }\n\n.m-TextWithIcon__text {\n  overflow: hidden; }\n", ""]);

// exports
